import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Button, Header, Input } from "semantic-ui-react";

const FilterComponent = ({ filterText, onFilter, onClear, placeholder }) => (
  <>
    <Input
      id="search"
      type="text"
      placeholder={placeholder}
      aria-label="Search Input"
      value={filterText}
      onChange={onFilter}
    />
    <Button type="button" onClick={onClear}>
      X
    </Button>
  </>
);

export const Tabla = ({
  columnas,
  datos,
  placeholder = "Buscar",
  comparacion,
}) => {
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  if (comparacion == null) {
    comparacion = (item, filterText) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase());
  }
  const filteredItems = datos.filter((item) => comparacion(item, filterText));

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
        placeholder={placeholder}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <DataTable
      columns={columnas}
      data={filteredItems}
      subHeaderComponent={subHeaderComponentMemo}
      pagination
      subHeader
      persistTableHead
      noDataComponent={
        filterText != "" ? (
          <h4 className="mt-10 mb-10">
            No hay resultados para la búsqueda "{filterText}"
          </h4>
        ) : (
          <h4 className="mt-10 mb-10">No hay datos para mostrar</h4>
        )
      }
      paginationComponentOptions={{
        rowsPerPageText: "Filas por página",
        rangeSeparatorText: "de",
      }}
    />
  );
};
